/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AirspaceJurisdictionDto } from './airspaceJurisdictionDto';
import { AuthorityTypeActions } from './authorityTypeActions';
import { RpaAuthorityDto } from './rpaAuthorityDto';
import { SimpleOrganisationDto } from './simpleOrganisationDto';

/**
 * A grouping of authorities for an RPA for a single endorsement type
 */
export interface RpaAuthorityGroup {
    /**
     * ${swagger.AuthorityType.id}
     */
    id: number;
    /**
     * The name of this authority type
     */
    name: string;
    /**
     * Does the authority have an expiry date
     */
    hasExpiry: boolean;
    /**
     * This authority type will also record an identifier such as a serial number
     */
    hasIdentifier: boolean;
    /**
     * Does the authority type support multiple instances
     */
    hasMultipleInstances: boolean;
    /**
     * How/when/by who is the authority issued?
     */
    issuingMechanism: RpaAuthorityGroup.IssuingMechanism;
    /**
     * Should this authority type be hidden in the UI from creation
     */
    hidden: boolean;
    /**
     * Can the authority have a name set by the user
     */
    hasName: boolean;
    /**
     * Any authorities of this type that exist for this RPA
     */
    authorities?: Array<RpaAuthorityDto>;
    /**
     * The actions that can be performed by the current user
     */
    availableActions: AuthorityTypeActions;
    /**
     * The customised name for identifier
     */
    identifierLabel?: string;
    /**
     * The associated jurisdiction of an authority type
     */
    jurisdiction: AirspaceJurisdictionDto;
    /**
     * The organisation that issues the authority
     */
    issuedBy?: SimpleOrganisationDto;
    /**
     * Help text that describes how to get this authority type
     */
    helperText: string;
    /**
     * A short description of the authority type
     */
    description: string;
    /**
     * The type of organisation that this authority applies to
     */
    appliesTo: RpaAuthorityGroup.AppliesTo;
    selfReported: boolean;
}
export namespace RpaAuthorityGroup {
    export type IssuingMechanism =
        | 'SELF_REPORTED'
        | 'ISSUER'
        | 'AUTOMATIC'
        | 'SELF_ISSUED';
    export const IssuingMechanism = {
        SELF_REPORTED: 'SELF_REPORTED' as IssuingMechanism,
        ISSUER: 'ISSUER' as IssuingMechanism,
        AUTOMATIC: 'AUTOMATIC' as IssuingMechanism,
        SELF_ISSUED: 'SELF_ISSUED' as IssuingMechanism
    };
    export type AppliesTo = 'PERSONAL' | 'COMMERCIAL' | 'RPA';
    export const AppliesTo = {
        PERSONAL: 'PERSONAL' as AppliesTo,
        COMMERCIAL: 'COMMERCIAL' as AppliesTo,
        RPA: 'RPA' as AppliesTo
    };
}
